export const getColumnDataFieldByMatchingPreference = (array, object, field='dataField') => {
   return array.filter((single_obj, index) => {
        if (object?.[single_obj[field]] === false) {
            return single_obj;
        }
        if (object?.[single_obj[field]]) {
            return single_obj;
        }
    });
}

export const getColumnDataFieldByNotMatchingPreference = (array, object, field='dataField') => {
    return array.filter((single_obj, index) => {
        if (object?.[single_obj[field]] === undefined) {
            return single_obj;
        }
    });
}